module.exports = __webpack_public_path__ + "img/linkedinAlert.c8ecaf1e.svg";